import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import SelectedPlansProvider from '../contexts/SelectedPlans';
import CorpClubBeneficiaries from './CorpClubBeneficiaries';
import CorpClubProfile from './CorpClubProfile';
import SelectedMembersProvider from '../contexts/SelectedMembers';
import { ExtractProvider } from '../contexts/ExtractContext';

export const MainRoutes = () => {
  const [searchParams] = useSearchParams();

  const page = searchParams.get('p');

  const templatePage = useMemo(() => {
    switch (page) {
      case 'perfil-colaborador':
        return (
          <SelectedPlansProvider>
            <CorpClubProfile />
          </SelectedPlansProvider>
        );
      default:
        return <CorpClubBeneficiaries />;
    }
  }, [page]);

  return (
    <ExtractProvider>
      <SelectedMembersProvider>{templatePage}</SelectedMembersProvider>
    </ExtractProvider>
  );
};
export { CorpClubBeneficiaries, CorpClubProfile };
